import * as z from "zod";

export const cancelManualFulfillments = {
  name: "cancelManualFulfillments" as const,
  input: z.object({ fulfillmentGroupIds: z.array(z.string()) }),
  output: z.object({
    success: z.boolean(),
    unCancellableFulfillmentGroupIds: z.array(z.string()),
  }),
};
